import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {XMLHttpRequestHandler} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {pagination_template} from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {networkGroupsList_template} from "../components/templates/networkGroupsList_template";
import {XMLHttpRequestHandler_requestType} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";

declare var ko: any;
declare var page: any;

export class networkGroups extends vnModule_knockoutJS{

    public XHRHdl: XMLHttpRequestHandler;
    protected networkGroupList: networkGroupsList_template;
    protected pagination: pagination_template;

    protected getModuleName(){
        return "networkGroups";
    }

    buildContent() : Array<Element>{

        // create validation errors list template
        // create the users list
        this.networkGroupList = new networkGroupsList_template("networkGroupList", this.viewModel, this);

        return [this.networkGroupList.build()];
    }

    public fillPage() : void {
        this.getListData();
    }

    /**
     *
     * @param id
     * @protected
     */
    protected viewNetworkGroup(id){
        page('/network_groups/view/'+id);
    }


    protected addNetworkGroup(): void {

        page('/network_groups/edit');
    }

    protected deleteNetworkGroup(id): void {
        this.deleteGroup(id);
    }

    protected paginationOnPageClick(): void {
        this.getListData();
    }

    public networkGroupsListReorder(): void {
        this.getListData();
    }

    /**
     *
     * @protected
     */
    protected filterSimpleOnChange(): void {
        this.networkGroupList.resetPageNumber();
        this.getListData();
    }

    /**
     *
     * @protected
     */
    protected filterSimpleCancel(): void {

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }
    }


    /**
     * @protected
     */
    protected getListData(): void {

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        // LOADING : starts
        this.loadingIn(this.networkGroupList.builtTemplate.children.namedItem("list-results"));

        let usrReq_url: string = '/api/network_groups/get';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(this.networkGroupList.getViewModelForRequest())] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onDataRequestReturn;
        this.XHRHdl.execute();
    }

    /**
     *
     * @param req
     * @param obj
     * @protected
     */
    protected onDataRequestReturn(req, obj): Function {
        return function(){
            obj.manageResponse(req, obj, function(){
                if (req.request.status == 200) {
                    let responseParsed = JSON.parse(req.request.response);
                    obj.updateList(responseParsed);
                }
            });
            obj.loadingOut(obj.networkGroupList.builtTemplate.children.namedItem("list-results"));
        }
    }

    //
    // update the module list using the objects list
    protected updateList(responseParsed: any): void {

        this.networkGroupList.setNetworkGroups(responseParsed.data);

        let execTime = Math.round((new Date().getTime() - this.XHRHdl.requestStartTime)/1000*100)/100;
        this.networkGroupList.setResultInfo(responseParsed.totalCount, responseParsed.totalPage,execTime );

        // update the paginator
        this.networkGroupList.setPaginationTotalCount(responseParsed.totalCount);
    }

    protected filterDropdownOnChange(): void {
        this.getListData();
    }

    protected deleteGroup(id: number): void {

        let formReq_params: Array<Array<string>> = [];

        let XHRHdl:XMLHttpRequestHandler = new XMLHttpRequestHandler('/api/network_groups/delete/'+id , formReq_params, this);
        XHRHdl.mode                      = XMLHttpRequestHandler_requestType.GET;
        XHRHdl.onReadyStateFunction      = this.onDeleteReturn;
        XHRHdl.execute();
    }

    /**
     * Handles delete response.
     *
     * @param req
     * @param obj
     * @return {function(): void}
     */
    protected onDeleteReturn(req, obj): Function{

        return function(){

            obj.manageResponse(req, obj, function(){

                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, 'Network group deleted successfully!');
                obj.getVnAppZone().showNotificationToModule();

                obj.getListData();
            });
        }
    }
}


// WEBPACK FOOTER //
// ./js/modules/networkGroups.ts